/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SSOCodeExchangeResponse
 */
export interface SSOCodeExchangeResponse {
    /**
     * 
     * @type {string}
     * @memberof SSOCodeExchangeResponse
     */
    accessToken: string;
    /**
     * 
     * @type {string}
     * @memberof SSOCodeExchangeResponse
     */
    refreshToken: string;
    /**
     * 
     * @type {string}
     * @memberof SSOCodeExchangeResponse
     */
    idToken: string;
    /**
     * 
     * @type {number}
     * @memberof SSOCodeExchangeResponse
     */
    expiresIn: number;
    /**
     * 
     * @type {string}
     * @memberof SSOCodeExchangeResponse
     */
    tokenType: string;
}

/**
 * Check if a given object implements the SSOCodeExchangeResponse interface.
 */
export function instanceOfSSOCodeExchangeResponse(value: object): value is SSOCodeExchangeResponse {
    if (!('accessToken' in value) || value['accessToken'] === undefined) return false;
    if (!('refreshToken' in value) || value['refreshToken'] === undefined) return false;
    if (!('idToken' in value) || value['idToken'] === undefined) return false;
    if (!('expiresIn' in value) || value['expiresIn'] === undefined) return false;
    if (!('tokenType' in value) || value['tokenType'] === undefined) return false;
    return true;
}

export function SSOCodeExchangeResponseFromJSON(json: any): SSOCodeExchangeResponse {
    return SSOCodeExchangeResponseFromJSONTyped(json, false);
}

export function SSOCodeExchangeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SSOCodeExchangeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'accessToken': json['accessToken'],
        'refreshToken': json['refreshToken'],
        'idToken': json['idToken'],
        'expiresIn': json['expiresIn'],
        'tokenType': json['tokenType'],
    };
}

export function SSOCodeExchangeResponseToJSON(json: any): SSOCodeExchangeResponse {
    return SSOCodeExchangeResponseToJSONTyped(json, false);
}

export function SSOCodeExchangeResponseToJSONTyped(value?: SSOCodeExchangeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accessToken': value['accessToken'],
        'refreshToken': value['refreshToken'],
        'idToken': value['idToken'],
        'expiresIn': value['expiresIn'],
        'tokenType': value['tokenType'],
    };
}

